import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts'; // ✅ blog verisi
import Navbar from '../components/NavBar';

const HomePage = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('Ziyaretçi');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload?.username) {
          navigate('/panel');
          return;
        }
      } catch {}
    }
    setUsername('Ziyaretçi');
  }, [navigate]);

  const latestPosts = [...blogPosts]
    .sort((a, b) => new Date(b.date) - new Date(a.date))
    .slice(0, 3); // ✅ sadece son 3 yazı

  return (
    <>
      <style>
        {`
          @keyframes zoomFadeIn {
            0% { transform: scale(1); opacity: 0; }
            100% { transform: scale(1.08); opacity: 1; }
          }

          @keyframes fadeInFast {
            from { opacity: 0; transform: translateY(10px); }
            to { opacity: 1; transform: translateY(0); }
          }

          body {
            margin: 0;
            padding: 0;
          }
        `}
      </style>

      <Navbar username={username} />

      <div style={{ position: 'relative', minHeight: '100vh' }}>
        {/* 🔹 Arka Plan */}
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: 'url("/assets/home-bg.png")',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            zIndex: -1,
          }}
        />

        {/* 🔹 Üst Kutucuk */}
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            paddingTop: '120px',
            paddingBottom: '40px',
          }}
        >
          <div
            style={{
              background: 'rgba(255, 255, 255, 0.1)',
              borderRadius: '20px',
              padding: '40px 30px',
              backdropFilter: 'blur(60px)',
              boxShadow: '0 8px 24px rgba(0,0,0,0.2)',
              maxWidth: '960px',
              width: '100%',
              textAlign: 'center',
              color: '#fff',
              animation: 'fadeInFast 0.5s ease-out',
            }}
          >
            <h1
              style={{
                fontSize: '2.4rem',
                fontWeight: '800',
                marginBottom: '20px',
                color: '#f1f5f9',
                textShadow: '1px 1px 2px rgba(0,0,0,0.6)',
              }}
            >
              HVAC Ürünlerinizi Tasarlayın
            </h1>
            <p
              style={{
                fontSize: '1.05rem',
                color: '#e2e8f0',
                lineHeight: '1.6',
                textShadow: '1px 1px 3px rgba(0,0,0,0.7)',
                marginBottom: '36px',
              }}
            >
              Klima Santrali, IGK, VRF/VRV ve Fan Grubu cihazlarınızı kolayca seçin.
              <br />
              <strong>
                <em>Giriş yaparak, projelerinizi oluşturun, kaydedin ve teklif isteyin.</em>
              </strong>
            </p>

            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 16,
                justifyContent: 'center',
              }}
            >
              <button onClick={() => navigate('/tasarim')} style={mainBtn('#3b82f6')}>
                🌬️ Klima Santrali
              </button>
              <button onClick={() => navigate('/igk-secim')} style={mainBtn('#10b981')}>
                ♻️ Isı Geri Kazanım Cihazı
              </button>
              <button onClick={() => navigate('/vrf')} style={mainBtn('#8b5cf6')}>
                ❄️ VRF / VRV
              </button>
              <button onClick={() => navigate('/fan-secim')} style={mainBtn('#f97316')}>
                🌀 Fan Grubu
              </button>
            </div>
          </div>
        </div>

{/* 🔹 En Yeni Blog Yazıları */}
<div
  style={{
    background: 'transparent',
    padding: '60px 20px',
    maxWidth: '1280px',
    margin: '0 auto',
  }}
>
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
      gap: '30px',
    }}
  >
    {latestPosts.map((post) => (
      <div
        key={post.slug}
        onClick={() => navigate(`/blog/${post.slug}`)}
        style={{
          backgroundColor: '#fff',
          borderRadius: 12,
          boxShadow: '0 4px 16px rgba(0,0,0,0.06)',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          cursor: 'pointer',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-4px)';
          e.currentTarget.style.boxShadow = '0 6px 20px rgba(0,0,0,0.12)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.06)';
        }}
      >
        <img
          src={post.image}
          alt={post.title}
          style={{
            width: '100%',
            height: 180,
            objectFit: 'cover',
            borderRadius: '8px',
            marginBottom: '16px',
          }}
        />
        <div style={{ padding: '20px 24px', flex: 1 }}>
          <h3 style={{ fontSize: '1.4rem', marginBottom: 6, color: '#1e293b' }}>
            {post.title}
          </h3>
          <p style={{ color: '#64748b', fontSize: '0.9rem', marginBottom: 4 }}>
            📅 {post.date} &nbsp;&nbsp;|&nbsp;&nbsp; 🏷️ {post.category}
          </p>
          <p style={{ fontSize: '1rem', color: '#334155', margin: '12px 0 20px' }}>
            {post.excerpt}
          </p>
          <button
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/blog/${post.slug}`);
            }}
            style={{
              padding: '10px 16px',
              backgroundColor: '#2563eb',
              color: 'white',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              fontWeight: '600',
            }}
          >
            Devamını Oku →
          </button>
        </div>
      </div>
    ))}
  </div>

  {/* 🔹 Tüm yazılar butonu */}
  <div style={{ textAlign: 'center', marginTop: 40 }}>
    <button
      onClick={() => navigate('/blog')}
      style={{
        backgroundColor: '#1e3a8a',
        color: '#fff',
        padding: '12px 24px',
        border: 'none',
        borderRadius: '8px',
        fontSize: '1rem',
        cursor: 'pointer',
        fontWeight: '600',
      }}
    >
      🔍 Tüm Yazılar
    </button>
  </div>
</div>

      </div>
    </>
  );
};

const mainBtn = (bgColor) => ({
  backgroundColor: bgColor,
  color: 'white',
  border: 'none',
  padding: '14px 28px',
  borderRadius: '10px',
  fontWeight: '600',
  fontSize: '1rem',
  cursor: 'pointer',
  boxShadow: `0 4px 12px ${bgColor}80`,
  transition: 'all 0.3s ease',
});

export default HomePage;
